<template>
    <span v-if="session.registration_deadline">
        <template v-if="course.registration_level === 'APPLICATION'">
            candidature
        </template>
        <template v-else>
            inscription
        </template>
        jusqu’au
        <template v-if="block">
            <span class="d-inline d-md-block">
                {{ dateLabel }}
            </span>
        </template>
        <template v-else>
            {{ dateLabel }}
        </template>
    </span>
</template>

<script>
    export default {
        props: {
            course: Object,
            session: Object,
            block: Boolean,
        },
        computed: {
            dateLabel() {
                const date = new Date(this.session.registration_deadline);

                // YYYY-MM-DD format
                if(this.session.registration_deadline.length === 10) {
                    return new Intl.DateTimeFormat('fr-FR', { dateStyle: 'full' }).format(date);
                }

                return new Intl.DateTimeFormat('fr-FR', {
                    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
                    hour: date.getHours() ? 'numeric' : undefined,
                    minute: date.getMinutes() ? 'numeric' : undefined,
                }).format(date);
            }
        }
    }
</script>
